<script>
  import {getContext} from 'svelte';
  import {fixLink$} from '@/store/lang';
  import {PATHS} from '@/const/paths';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
</script>

<style>
  .preheat-text {
    margin-top: -18px;
    padding: 0 10px 60px 36px;
    line-height: 26px;
    text-align: right;
    font-size: 20px;
    color: #fff;
    white-space: nowrap;
  }
  .shining {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-weight: 700;
    background: linear-gradient(271deg, #4a7cff 17.27%, #36f0cf 81.03%, #4a7cff 100%);
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    gap: 4px;
    animation: shine 2s linear infinite;
  }
  .join {
    line-height: 22px;
    color: rgba(255, 255, 255, 0.8);
  }
  @keyframes shine {
    100% {
      background-position: -200%;
    }
  }
  @media screen and (max-width: 640px) {
    .preheat-text {
      text-align: left;
    }
  }
</style>

<div class="preheat-text">
  <div class="shining cp">
    {LG(lang.PulseSeason3)}
    <img width="20" height="20" alt="Entry" src={IMAGES.ARROW_RIGHT} />
  </div>
  <div class="join f16">{LG(lang.PulseCastRule)}</div>
</div>
